/**
 * Emoji a member can show beside their welcome message on the profile hero
 * (BH-41). Stored in users.welcome_emoji; the quick picks below are only
 * shortcuts — any single emoji is accepted, validated server-side by
 * App\Rules\SingleEmoji.
 */
export const DEFAULT_WELCOME_EMOJI = "🥳";

export const welcomeEmoji = ["🥳", "🎁", "👋", "🎉", "❤️", "🎂", "✨", "😊"];

// A pictograph (optionally with a variation selector or skin tone, joined
// into a ZWJ sequence or followed by a tag sequence), a two-letter flag, or
// a keycap. Mirrors App\Rules\SingleEmoji.
const SINGLE_EMOJI =
    /^(?:\p{Regional_Indicator}{2}|[0-9#*]️?⃣|\p{Extended_Pictographic}(?:️|\p{Emoji_Modifier})?(?:‍\p{Extended_Pictographic}(?:️|\p{Emoji_Modifier})?)*(?:[\u{E0020}-\u{E007E}]+\u{E007F})?)$/u;

function firstGrapheme(text) {
    if (typeof Intl !== "undefined" && Intl.Segmenter) {
        const segmenter = new Intl.Segmenter(undefined, {
            granularity: "grapheme",
        });
        for (const { segment } of segmenter.segment(text)) {
            return segment;
        }
        return "";
    }

    return Array.from(text)[0] ?? "";
}

/**
 * The first emoji in `text` when it starts with one, else null. Lets a
 * free-text input accept a paste or an OS emoji keyboard entry and keep
 * just the emoji.
 */
export function firstEmoji(text) {
    const cluster = firstGrapheme((text ?? "").trim());

    return cluster && SINGLE_EMOJI.test(cluster) ? cluster : null;
}
